import React, { useEffect } from 'react';
import About from './About.jsx';
import Home from './Home.jsx';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";

function ScrollToTopOnRouteChange() {
  const location = useLocation();
  useEffect(() => {
    // Collapse navbar on route change (hide mobile menu)
    const navbar = document.getElementById('navbarMenu');
    if (navbar && navbar.classList.contains('show')) {
      const bsCollapse = window.bootstrap.Collapse.getInstance(navbar);
      if (bsCollapse) bsCollapse.hide();
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTopOnRouteChange />

      {/* Navbar */}
      <nav className="navbar navbar-expand-md navbar-light mb-3 flex-column align-items-stretch position-relative">
        {/* Top row */}
        <div className="container-fluid d-flex align-items-center justify-content-between w-100">

          {/* Left: Logo (fixed width box for centering stability) */}
          <Link className="navbar-brand d-flex align-items-center justify-content-center" to="/" style={{ width: 56 }}>
            <img
              src="/images/logo_kesw.png"
              alt="Kathryn Watt logo"
              style={{ height: 40, width: "auto", maxWidth: "100%", objectFit: "contain" }}
            />
          </Link>

          {/* Middle: Name */}
          <div className="flex-fill text-center">
            {/* Desktop: large centered name */}
            <span
              className="fw-bold fs-3 d-none d-md-inline"
              style={{ fontFamily: "serif", letterSpacing: "1px" }}
            >
              KATHRYN WATT
            </span>

            {/* Mobile: smaller inline version */}
            <span
              className="fw-bold fs-5 d-md-none"
              style={{ fontFamily: "serif" }}
            >
              KATHRYN WATT
            </span>
          </div>

          {/* Right: Hamburger (mobile only) */}
          <button
            className="navbar-toggler d-md-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarMenu"
            aria-controls="navbarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ width: 56 }}  // balances with left logo width
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Right: Invisible spacer (desktop only) */}
          <div className="d-none d-md-block" style={{ width: 56 }} />
        </div>

        {/* Second row: collapsible nav menu */}
        <div className="collapse navbar-collapse w-100 justify-content-center" id="navbarMenu">
          <div className="navbar-nav text-center">
            <Link to="/" className="nav-link mx-2">Home</Link>
            <Link to="/about" className="nav-link mx-2">About Me</Link>
            <a
              href="/images/Watt_Kathryn_Resume.pdf"
              target="_blank"
              rel="noreferrer"
              className="nav-link mx-2"
            >
              Resume
            </a>
          </div>
        </div>
      </nav>

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App;
